import { Box } from '@mui/material';
import { useStyles } from './TreatmentPlan.styles';
import { Icons } from '../../../../../icons';
import { btnType, Button } from '../../../../atoms/button';
import { iconBtnPosition, iconBtnType } from '../../../../molecules/icon-button';
import clsx from 'clsx';
import LottieMedicalBook from '../../../../../icons/lotties/lottieIcons/MedicalBook';

/**
 * Modalities display component - reusable across treatment plan views
 */
const Modalities = ({ modalities, onAddEditModalities }) => {
  const classes = useStyles();

  const renderEmptyState = () => {
    return (
      <Box display="flex" flexDirection="column" gap="16px">
        <Box display="flex" gap="8px" alignItems="center">
          <Box width={80} maxWidth={80} maxHeight={80}>
            <LottieMedicalBook />
          </Box>
          <Box display="flex" flexDirection="column" gap="4px">
            <span className={classes.bodyUuid}>Select your modalities</span>
            <span className={classes.bodyServiceName}>
              We use this to help develop notes and treatment plans
            </span>
          </Box>
        </Box>
      </Box>
    );
  };

  const renderModalitiesList = () => {
    return (
      <Box className={classes.modalitiesList}>
        {modalities?.map((item, index) => (
          <Box key={index} className={classes.modalitiesListItem}>
            <Icons glyph={'check-circle'} className={classes.checkIcon} />
            <Box>{item}</Box>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.produreContainer}>
        <Box className={classes.header}>
          <Box>Modalities to be used</Box>
          <Box>
            {modalities === null || modalities?.length === 0 ? (
              <Button
                className={classes.editBtn}
                variant={iconBtnType.TEXT}
                onClick={onAddEditModalities}
                iconPosition={iconBtnPosition.RIGHT}
              >
                Add modality
              </Button>
            ) : (
              <Button
                className={classes.editBtn}
                variant={iconBtnType.TEXT}
                onClick={onAddEditModalities}
                iconPosition={iconBtnPosition.RIGHT}
              >
                Edit
              </Button>
            )}
          </Box>
        </Box>
        <Box className={clsx(classes.body)}>
          {!modalities || modalities.length === 0 ? renderEmptyState() : renderModalitiesList()}
        </Box>
      </Box>
    </Box>
  );
};

export { Modalities };

